import * as React from 'react';

import {ListView} from '../list-view/list-view';
import type {ListViewProps} from '../list-view/list-view';

import {PopoverListHeader} from './popover-list-header';

import styles from './popover-list.module.css';

type Props = {
    title: string;
    viewAllLink: string;
    height?: number;
} & ListViewProps;

export function PopoverList(props: Props) {
    const {title, viewAllLink, height, ...listViewProps} = props;

    return (
        <div style={height ? {minHeight: `${height}px`} : undefined} className={styles.container}>
            <PopoverListHeader title={title} viewAllLink={viewAllLink} />
            <div
                style={height ? {height: `${height}px`} : undefined}
                className={styles['list-container']}
            >
                <ListView {...listViewProps} itemSpacing={8} />
            </div>
        </div>
    );
}
